import { Injectable, EventEmitter } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { IErrorContent } from "../interfaces/loan-result.interface";

@Injectable()
export class ValidationErrorsService {

  public serverErrors: { [fieldName: string]: string; } = {};


  constructor() {
  }

  markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      if (control.controls) { // control is a FormGroup
        this.markFormGroupTouched(control);
      } else { // control is a FormControl
        if (!control.hasError('serverError')) {
          control.markAsTouched();
          control.markAsDirty();
          control.updateValueAndValidity();
        }

      }
    });

    if (!formGroup.valid) {
      this.scrollToError(null);
    }
  }

  manageServerErrors(formGroup: FormGroup, serverErrors: IErrorContent[]) {
    serverErrors.forEach(error => {

      if (error.FieldName == null) {
          this.serverErrors['generalError'] = error.Message;
      } else {
        var control = formGroup.get(error.FieldName);
        if (control) {
          control.setErrors({ 'serverError': true });
          this.serverErrors[error.FieldName] = error.Message;
        }
      }



    });
    if (!formGroup.valid) {
      this.scrollToError(serverErrors[0].FieldName);
    }

  }


  scrollToError(fieldName: string) {

    var element;
if (fieldName) {
  element = document.querySelector('[formcontrolname="' + fieldName + '"]');
} else {
  element = document.querySelector('.ng-invalid:not(form):not(section)');

}

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }
    validateForm(form : FormGroup) : boolean{
        this.markFormGroupTouched(form);

        if (!form.valid) {
            this.scrollToError(null);
        }

        return form.valid;
    }
}
